var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rocketIcon_svg__clip0_4142_5397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.637.351c.733 3.12.242 6.59-.444 9.692-1.513 6.849-4.983 13.349-10.245 18.044.184 3.746 1.305 7.058-1.436 10.207-1.355 1.556-6.488 4.743-8.464 5.919-.91.54-1.498 1.006-2.617.679-.795-.233-1.423-.9-1.684-1.668l-.678-8.428c-5.022.054-9.056-3.96-9.12-8.928-.072-.084-1.9-.203-2.214-.225-1.52-.107-3.155-.07-4.66-.218-2.225-.218-3.7-1.226-2.81-3.65 2.474-3.1 4.454-8.94 8.246-10.551 2.746-1.167 5.324-.322 8.17-.174C21.447 5.755 28.013 2.298 34.99.792 38.085.124 41.52-.362 44.637.35v.001zm-17.29 9.816c-4.893 4.86 2.741 12.288 7.556 7.236 4.635-4.863-2.686-12.073-7.556-7.236z",
    fill: "#41AAAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.662 35.874c-.788-.173-1.147-1.252-.655-1.943.986-1.382 3.14-2.793 4.231-4.199.557-.339 1.154-.176 1.581.267.47.913.784 1.901 1.317 2.785 1.025 1.7 2.688 3.272 4.463 4.185 1.25.644 3.723.956 2.187 2.893-.425.535-3.702 3.778-4.139 3.967-.47.203-1.102.125-1.45-.28-.059-.069-.322-.575-.322-.618v-2.1L3.48 42.53c-.998-.099-1.345-.654-1.193-1.62.217-1.374 1.233-3.17 1.552-4.599.032-.145.068-.285.049-.436-.638-.095-1.639.129-2.223 0h-.002z",
    fill: "#FFBC3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.347 10.168c4.87-4.837 12.19 2.372 7.556 7.236-4.815 5.052-12.45-2.376-7.556-7.236z",
    fill: "#058181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rocketIcon_svg__clip0_4142_5397"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h45v45H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/rocketIcon.1202378d.svg";
export { MemoForwardRef as ReactComponent };